<h1 mat-dialog-title class="dialog-title-container">
  Reset Password
</h1>
<button mat-icon-button type="button" class="close-icon" (click)="onClose()" aria-label="Close">
  <mat-icon>close</mat-icon>
</button>

<div mat-dialog-content class="custom-dialog-content">
  <form [formGroup]="userForm" autocomplete="off" class="reset-password-form">
    <div class="form-bgd">
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline" floatLabel="always" class="form-feild">
            <mat-label class="asterix--before">Password</mat-label>
            <input matInput
              class="form-controll"
              [type]="showPassword ? 'text' : 'password'"
              name="password"
              formControlName="password"
              autocomplete="new-password" />
            <button mat-icon-button matSuffix type="button" (click)="toggleShowPassword()" tabindex="-1">
              <mat-icon>{{ !showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="userForm?.controls['password']?.touched && userForm?.controls['password']?.hasError('required')">
              {{ errorMessageFormField?.user_password }}
            </mat-error>
            <mat-error *ngIf="userForm?.controls['password']?.touched && userForm?.controls['password']?.hasError('passwordStrength')">
              {{ errorMessageFormField?.passwordStrength }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field appearance="outline" floatLabel="always" class="form-feild">
            <mat-label class="asterix--before">Confirm Password</mat-label>
            <input matInput
              class="form-controll"
              [type]="showConfirmPassword ? 'text' : 'password'"
              name="confirmpassword"
              formControlName="confirmpassword"
              autocomplete="new-password" />
            <button mat-icon-button matSuffix type="button" (click)="toggleConfirmPassword()" tabindex="-1">
              <mat-icon>{{ !showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="userForm?.controls['confirmpassword']?.touched && userForm?.controls['confirmpassword']?.hasError('required')">
              {{ errorMessageFormField?.confirmpassword }}
            </mat-error>
            <mat-error *ngIf="userForm?.controls['confirmpassword']?.touched && userForm?.controls['confirmpassword']?.hasError('passwordStrength')">
              {{ errorMessageFormField?.passwordStrength }}
            </mat-error>
            <mat-error *ngIf="userForm.get('confirmpassword')?.hasError('passwordMismatch')">
              {{ errorMessageFormField?.passwordMatch }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions class="dialog-actions text-center">
  <button mat-stroked-button type="button" color="basic" class="back" (click)="onClose()">Cancel</button>
  <button mat-raised-button type="button" class="select-btn" (click)="changePassword()" [disabled]="userForm.invalid">Reset</button>
</div>
